/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { cached, tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import { type Registry as Services, service } from '@ember/service';
import { waitFor } from '@ember/test-waiters';
import { animatedTransition } from 'uplisting-frontend/utils/router';
import type { ModelRegistry } from 'ember-data/types/registries/model';

interface IArgs {
  booking: ModelRegistry['booking'];
}

export interface BookingV2FooterSignature {
  Element: null;

  Args: IArgs;
}

const OWN_FOOTER_ROUTES = [
  '.bookings.summary.accept',
  '.bookings.summary.modify',
];

export default class UiBookingV2FooterComponent extends Component<BookingV2FooterSignature> {
  @service router!: Services['router'];

  @service('booking-drawer')
  bookingDrawer!: Services['booking-drawer'];

  @tracked showPropertyChangeConfirmModal = false;

  @cached
  get booking(): ModelRegistry['booking'] {
    return this.args.booking;
  }

  get isVisible(): boolean {
    const currentRouteName = this.router.currentRouteName ?? '';

    return (
      this.bookingDrawer.isOpen &&
      !OWN_FOOTER_ROUTES.some((route) => currentRouteName.includes(route))
    );
  }

  @action
  handleClose(): void {
    const [parent] = (this.router.currentRouteName ?? '').split('.bookings.');

    if (!parent) {
      return;
    }

    animatedTransition(() => this.router.transitionTo(parent));
  }

  @action
  handleUpdateClick(): void {
    if (this.bookingDrawer.hasChangedProperty) {
      this.showPropertyChangeConfirmModal = true;
    } else {
      this.handleUpdate();
    }
  }

  @action
  handleCloseModal(): void {
    if (!this.bookingDrawer.isSubmitting) {
      this.booking.newProperty = undefined;
    }

    this.showPropertyChangeConfirmModal = false;
  }

  @action
  @waitFor
  async handleUpdate(): Promise<void> {
    this.showPropertyChangeConfirmModal = false;

    await this.bookingDrawer.update();
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Ui::BookingV2::Footer': typeof UiBookingV2FooterComponent;
  }
}
